import React, { FC } from 'react';
import { useCallback, useState } from 'react';
import LoaderStep from './LoaderStep';

import StartGameStep1, { Inputs } from './Step1';
import StartGameStep2 from './Step2';

interface IProps {
  toggleModal: () => void;
}

const StartGameForm: FC<IProps> = ({ toggleModal }) => {
  const [isDisplayStep2, setIsDisplayStep2] = useState(false);
  const [names, setNames] = useState<Inputs>({ player1Name: '', player2Name: '' });

  const toggleIsDisplayStep2 = useCallback((data: Inputs) => {
    setIsDisplayStep2((prev) => !prev);
    setNames(data);
  }, []);

  const onTimeEnd = useCallback(() => {
    toggleModal();
    setIsDisplayStep2(false);
  }, [toggleModal]);

  return isDisplayStep2 ? (
    <LoaderStep
      names={names}
      onTimeEnd={onTimeEnd}
    />
  ) : (
    <StartGameStep1 onContinue={toggleIsDisplayStep2} />
  );
};

export default StartGameForm;
